import { DateTime } from "luxon"

export interface GetUnloadedFuelDataRequest {
    loadDateFrom: DateTime | null,
    loadDateTo: DateTime | null,
    departureAirport: string | null,
    arrivalAirport: string | null,
    flightNumber: string | null,
    acRegistration: string | null,
    sourceType: string | null,
    includeResolved: boolean
}